/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Col, Row, Table, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { featureCategoryInitialFormData } from './overview/featureCategory.schema';
import FeatureCategoryForm from './overview/FeatureCategoryForm';
import FeatureForm from './overview/FeatureForm';
import { featuresInitialFormData } from './overview/feature.schema';
import { PageHeader } from '../../components/page-headers/page-headers';
import { Button } from '../../components/buttons/buttons';
import { Main, TableWrapper } from '../styled';
import {
  deleteFeature,
  deleteFeatureCategory,
  getAllFeaturesCategory,
} from '../../redux/featuresCategory/actionCreator';
import { Modal } from '../../components/modals/antd-modals';
import DeleteConfirmationModal from '../../components/modals/DeleteConfirmationModal';
import Heading from '../../components/heading/heading';
import { Cards } from '../../components/cards/frame/cards-frame';
import { UserTableStyleWrapper } from '../pages/style';
import { DEFAULT_LANG, LANGUAGE_BY_DOMAIN } from '../../utils/constants';

const Features = () => {
  const dispatch = useDispatch();
  const { featuresCategory, loading } = useSelector(state => state.featuresCategory);
  const lang = Cookies.get('lang') ?? 'en';

  const [formData, setFormData] = useState({ ...featureCategoryInitialFormData });
  const [featureFormData, setFeatureFormData] = useState({ ...featuresInitialFormData });
  const [showModal, setShowModal] = useState({
    status: false,
    modalType: 'form', // modalType can be either 'form' or 'delete' or 'feature'
  });
  const [deleteItem, setDeleteItem] = useState(null);
  const [featureParent, setFeatureParent] = useState(null);
  const [pagination, setPagination] = useState({ currentPage: 1, pageLimit: 10 });

  useEffect(() => {
    getAllFeaturesCategory(dispatch);
  }, []);

  // For handling the close model
  const onCancel = () => {
    setShowModal({
      status: false,
      modalType: 'form',
    });
    setDeleteItem(null);
    setFeatureParent(null);
    setFormData({ ...featureCategoryInitialFormData });
    setFeatureFormData({ ...featuresInitialFormData });
  };

  const handleDeleteClick = (id, name) => {
    setDeleteItem({ id, category: name });
    setShowModal({
      status: true,
      modalType: 'delete',
    });
  };

  const handleFeatureDeleteClick = (id, name) => {
    setDeleteItem({ id, feature: name });
    setShowModal({
      status: true,
      modalType: 'delete',
    });
  };

  const handleDeleteConfirmation = async () => {
    try {
      const res = await dispatch(deleteFeatureCategory(deleteItem && deleteItem?.id));
      if (res?.data?.status) {
        onCancel();
        getAllFeaturesCategory(dispatch);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      onCancel();
      setDeleteItem(null);
    }
  };
  const handleFeatureDeleteConfirmation = async () => {
    try {
      const res = await dispatch(deleteFeature(deleteItem && deleteItem?.id));
      if (res?.data?.status) {
        onCancel();

        getAllFeaturesCategory(dispatch);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      onCancel();
      setDeleteItem(null);
    }
  };
  const handleToggleModal = modalType => {
    setShowModal({
      status: !showModal.status,
      modalType,
    });
  };

  const handleEditClick = responseData => {
    const apiResData = {
      _id: responseData?._id,
      isMultiLang: responseData?.details && responseData?.details.length > 1 ? 'true' : 'false',
    };

    let categoryFields = {};
    if (responseData?.details.length > 1) {
      // eslint-disable-next-line no-unused-vars
      LANGUAGE_BY_DOMAIN.forEach((langItem, index) => {
        categoryFields = {
          ...categoryFields,
          [`category${langItem[1]}`]: responseData?.details[index]?.category ?? '',
        };
      });
    } else {
      categoryFields = {
        ...categoryFields,
        [`category${DEFAULT_LANG.value}`]: responseData?.details[0]?.category ?? '',
      };
    }

    setFormData({
      ...formData,
      ...apiResData,
      ...categoryFields,
    });

    setShowModal({ status: true, modalType: 'form' });
  };
  const handleFeatureEditClick = responseData => {
    const apiResData = {
      _id: responseData?._id,
      isMultiLang: responseData?.details && responseData?.details.length > 1 ? 'true' : 'false',
    };

    let featuresFields = {};
    if (responseData?.details.length > 1) {
      // eslint-disable-next-line no-unused-vars
      LANGUAGE_BY_DOMAIN.forEach((langItem, index) => {
        featuresFields = {
          ...featuresFields,
          [`feature${langItem[1]}`]: responseData?.details[index]?.feature ?? '',
        };
      });
    } else {
      featuresFields = {
        ...featuresFields,
        [`feature${DEFAULT_LANG.value}`]: responseData?.details[0]?.feature ?? '',
      };
    }

    setFeatureFormData({
      ...featureFormData,
      ...apiResData,
      ...featuresFields,
    });

    setShowModal({ status: true, modalType: 'feature' });
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Actions',
      dataIndex: 'action',
      width: '90px',
      key: 'action',
    },
  ];
  const categories = [];
  featuresCategory?.map(category => {
    const { _id, details } = category;
    const localizedDetail = details.find(detail => detail.lang === lang);
    const children = [];
    category?.features?.map(feature => {
      const { _id: featureId, details: featureDetail } = feature;
      const localizedFeature = featureDetail.find(detail => detail.lang === lang);

      return children.push({
        key: featureId,
        name: (
          <div className="user-info">
            <Heading className="user-name" as="h6">
              {localizedFeature?.feature ?? ' -'}
            </Heading>
          </div>
        ),
        action: (
          <div className="table-actions">
            <Button
              className="btn-icon"
              type="info"
              to="#"
              shape="circle"
              onClick={() => {
                handleFeatureEditClick(feature);
                setFeatureParent(_id);
              }}
            >
              <FeatherIcon icon="edit" size={16} />
            </Button>
            <Button
              className="btn-icon"
              type="danger"
              to="#"
              shape="circle"
              onClick={() => {
                handleFeatureDeleteClick(featureId, localizedFeature?.feature);
              }}
            >
              <FeatherIcon icon="trash-2" size={16} />
            </Button>
          </div>
        ),
      });
    });

    return categories.push({
      key: _id,
      name: (
        <div className="user-info">
          <Heading className="user-name" as="h6">
            {localizedDetail?.category ?? ' -'}
          </Heading>
        </div>
      ),
      children,
      action: (
        <div className="table-actions">
          <div className="table-actions">
            <Tooltip title="Add feature">
              <Button
                className="btn-icon"
                type="success"
                to="#"
                shape="circle"
                onClick={e => {
                  e.stopPropagation();
                  setFeatureParent(_id);
                  handleToggleModal('feature');
                }}
              >
                <FeatherIcon icon="plus" size={16} />
              </Button>
            </Tooltip>
            <Button
              className="btn-icon"
              type="info"
              to="#"
              shape="circle"
              onClick={e => {
                e.stopPropagation();

                handleEditClick(category);
              }}
            >
              <FeatherIcon icon="edit" size={16} />
            </Button>
            <Button
              className="btn-icon"
              type="danger"
              to="#"
              shape="circle"
              onClick={e => {
                e.stopPropagation();
                handleDeleteClick(_id, localizedDetail?.category);
              }}
            >
              <FeatherIcon icon="trash-2" size={16} />
            </Button>
          </div>
        </div>
      ),
    });
  });
  return (
    <>
      <PageHeader
        ghost
        title="Features"
        buttons={[
          <Button
            onClick={() => handleToggleModal('form')}
            key="1"
            style={{ backgroundColor: '#155BDC', color: '#fff' }}
            size="default"
          >
            <FeatherIcon icon="plus" size={16} /> Add New Category
          </Button>,
        ]}
      />
      <Modal
        type="primary"
        title="Category Form"
        visible={showModal.modalType === 'form' && showModal.status}
        footer={null}
        onCancel={onCancel}
      >
        <div className="body-type-modal">
          <FeatureCategoryForm formData={formData} onCancel={onCancel} />
        </div>
      </Modal>
      <Modal
        type="primary"
        title="Feature Form"
        visible={showModal.modalType === 'feature' && showModal.status}
        footer={null}
        onCancel={onCancel}
      >
        <div className="body-type-modal">
          <FeatureForm formData={featureFormData} onCancel={onCancel} parent={featureParent} />
        </div>
      </Modal>
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Cards headless>
              <UserTableStyleWrapper>
                <TableWrapper className="table-responsive">
                  <Table
                    dataSource={categories}
                    columns={columns}
                    expandable={{ expandRowByClick: true, indentSize: 20 }}
                    rowClassName={() => 'clickable-row'}
                    pagination={{
                      defaultPageSize: pagination.pageLimit,
                      current: pagination.currentPage,
                      total: featuresCategory?.length,
                      showSizeChanger: true,
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    onChange={data =>
                      setPagination(prev => ({ ...prev, currentPage: data.current, pageLimit: data.pageSize }))
                    }
                  />
                </TableWrapper>
              </UserTableStyleWrapper>
            </Cards>
          </Col>
        </Row>
      </Main>

      <DeleteConfirmationModal
        title={deleteItem?.category ? 'Category' : 'Feature'}
        visible={showModal.modalType === 'delete' && showModal.status}
        onCancel={onCancel}
        handleDeleteConfirmation={deleteItem?.category ? handleDeleteConfirmation : handleFeatureDeleteConfirmation}
        deleteButtonLoading={loading}
        itemName={deleteItem?.name ?? ''}
      >
        Are you sure you want to delete{' '}
        <span style={{ fontWeight: 600 }}>{deleteItem?.category || deleteItem?.feature || 'this record'}</span> ?
      </DeleteConfirmationModal>
    </>
  );
};

export default Features;
